import { useState } from "react"
import { useLocation } from "react-router"
import { useSelectedAccount } from "../../contexts/AccountContext"
import AccountSelectorModal from "../account/AccountSelectorModal"
import OrgSelectorModal from "./OrgSelectorModal"
import "../../styles/header.scss"

type Props = {
  pageTitle: string
  onMenuOpen: () => void
  onBack?: () => void
}

const accountSelectorLabel = (selectedAccountIds: number[], singleAccountOnly: boolean, username: string | undefined): string => {
  if (selectedAccountIds.length === 0) return "アカウントなし"
  if (singleAccountOnly || selectedAccountIds.length === 1) return username ? `@${username}` : "アカウントを選択"
  return `${selectedAccountIds.length}アカウントを選択中`
}

const Header = ({ pageTitle, onMenuOpen, onBack }: Props) => {
  const location = useLocation()
  const isSettingsPage = location.pathname === "/settings"
  const { selectedAccount, selectedAccountIds, organizations, selectedOrganizationId, singleAccountOnly } = useSelectedAccount()
  const [showModal, setShowModal] = useState(false)

  const selectedOrg = organizations.find(o => o.id === selectedOrganizationId)

  return (
    <header className="app-header">
      <div className="app-header__left">
        <button
          className="app-header__menu-btn"
          onClick={onMenuOpen}
          aria-label="メニューを開く"
        >
          <i className="bi bi-list" />
        </button>
        {onBack && (
          <button
            className="app-header__back-btn"
            onClick={onBack}
            aria-label="戻る"
          >
            <i className="bi bi-chevron-left" />
            <span>戻る</span>
          </button>
        )}
        <h1 className="app-header__title">{pageTitle}</h1>
      </div>

      <div className="app-header__right">
        {isSettingsPage ? (
          <button
            className="account-selector"
            onClick={() => setShowModal(true)}
            aria-label="組織を選択"
          >
            <div className="account-selector__avatar">
              <i className="bi bi-building" />
            </div>
            <span className="account-selector__name">
              {selectedOrg?.name ?? "組織を選択"}
            </span>
            <i className="bi bi-chevron-down account-selector__chevron" />
          </button>
        ) : (
          <button
            className="account-selector"
            onClick={() => setShowModal(true)}
            aria-label="アカウントを選択"
          >
            <div className="account-selector__avatar">
              {(singleAccountOnly || selectedAccountIds.length === 1) && selectedAccount?.avatar_url ? (
                <img src={selectedAccount.avatar_url} alt={selectedAccount.username} className="account-selector__avatar-img" />
              ) : (
                <i className="bi bi-instagram" />
              )}
            </div>
            <span className="account-selector__name">
              {accountSelectorLabel(selectedAccountIds, singleAccountOnly, selectedAccount?.username)}
            </span>
            <i className="bi bi-chevron-down account-selector__chevron" />
          </button>
        )}
      </div>

      {showModal && isSettingsPage
        ? <OrgSelectorModal onClose={() => setShowModal(false)} />
        : showModal && <AccountSelectorModal onClose={() => setShowModal(false)} />
      }
    </header>
  )
}

export default Header
